// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:02 GMT

export const miles_tailwind_config = {
  colors: {
    "vibra-10": "#0D0F19",
    "vibra-20": "#191E33",
    "vibra-30": "#262D4C",
    "vibra-40": "#333C66",
    "vibra-50": "#3F4A80",
    "vibra-60": "#4C5999",
    "vibra-70": "#5968B2",
    "vibra-80": "#6677CC",
    "vibra-90": "#7286E5",
    "vibra-100": "#7F95FF",
    "vibra-110": "#8CA0FF",
    "vibra-120": "#99AAFF",
    "vibra-130": "#A5B5FF",
    "vibra-140": "#B2BFFF",
    "vibra-150": "#BFCAFF",
    "vibra-160": "#CCD5FF",
    "vibra-170": "#D9DFFF",
    "vibra-180": "#E5EAFF",
    "vibra-190": "#F2F4FF",
    "blu-10": "#070A18",
    "blu-20": "#0D1430",
    "blu-30": "#141E48",
    "blu-40": "#1B2860",
    "blu-50": "#213277",
    "blu-60": "#283C8F",
    "blu-70": "#2F46A7",
    "blu-80": "#3650BF",
    "blu-90": "#3C5AD7",
    "blu-100": "#4364EF",
    "blu-110": "#5673F1",
    "blu-120": "#6983F2",
    "blu-130": "#7B93F4",
    "blu-140": "#8EA2F5",
    "blu-150": "#A1B1F7",
    "blu-160": "#B4C1F9",
    "blu-170": "#C7D1FA",
    "blu-180": "#D9E0FC",
    "blu-190": "#ECF0FD",
    "bike-10": "#09140D",
    "bike-20": "#13281A",
    "bike-30": "#1C3C26",
    "bike-40": "#255033",
    "bike-50": "#2E6340",
    "bike-60": "#38774D",
    "bike-70": "#418B5A",
    "bike-80": "#4A9F66",
    "bike-90": "#54B373",
    "bike-100": "#5DC780",
    "bike-110": "#6DCD8D",
    "bike-120": "#7DD299",
    "bike-130": "#8ED8A6",
    "bike-140": "#9EDDB3",
    "bike-150": "#AEE3BF",
    "bike-160": "#BEE9CC",
    "bike-170": "#CEEED9",
    "bike-180": "#DFF4E6",
    "bike-190": "#EFF9F2",
    "bike-custom1": "#5E8F6E",
    "noise-0": "#000000",
    "noise-10": "#0D0D0D",
    "noise-14": "#121212",
    "noise-20": "#191919",
    "noise-25": "#202020",
    "noise-30": "#262626",
    "noise-40": "#333333",
    "noise-50": "#404040",
    "noise-60": "#4C4C4C",
    "noise-70": "#595959",
    "noise-80": "#666666",
    "noise-90": "#737373",
    "noise-100": "#808080",
    "noise-105": "#838488",
    "noise-110": "#8C8C8C",
    "noise-120": "#999999",
    "noise-130": "#A6A6A6",
    "noise-140": "#B2B2B2",
    "noise-150": "#BFBFBF",
    "noise-160": "#CCCCCC",
    "noise-170": "#D9D9D9",
    "noise-180": "#E5E5E5",
    "noise-190": "#F2F2F2",
    "noise-200": "#FFFFFF",
    "lumen-10": "#060418",
    "lumen-20": "#0B0830",
    "lumen-30": "#110C49",
    "lumen-40": "#171061",
    "lumen-50": "#1C1479",
    "lumen-60": "#221991",
    "lumen-70": "#281DA9",
    "lumen-80": "#2E21C1",
    "lumen-90": "#3325DA",
    "lumen-100": "#3929F2",
    "lumen-110": "#4D3EF3",
    "lumen-120": "#6154F5",
    "lumen-130": "#7469F6",
    "lumen-140": "#887FF7",
    "lumen-150": "#9C94F8",
    "lumen-160": "#B0A9FA",
    "lumen-170": "#C4BFFB",
    "lumen-180": "#D7D4FC",
    "lumen-190": "#EBEAFE",
    "oragano-10": "#181109",
    "oragano-20": "#302213",
    "oragano-30": "#47331C",
    "oragano-40": "#5F4426",
    "oragano-50": "#77552F",
    "oragano-60": "#8F6738",
    "oragano-70": "#A77842",
    "oragano-80": "#BE894B",
    "oragano-90": "#D69A55",
    "oragano-100": "#EEAB5E",
    "oragano-110": "#F0B36E",
    "oragano-120": "#F1BC7E",
    "oragano-130": "#F3C48E",
    "oragano-140": "#F5CD9E",
    "oragano-150": "#F6D5AE",
    "oragano-160": "#F8DDBF",
    "oragano-170": "#FAE6CF",
    "oragano-180": "#FCEEDF",
    "oragano-190": "#FDF7EF",
    "major-tom-10": "#150909",
    "major-tom-20": "#2A1212",
    "major-tom-30": "#401A1A",
    "major-tom-40": "#552323",
    "major-tom-50": "#6A2C2C",
    "major-tom-60": "#7F3535",
    "major-tom-70": "#943E3E",
    "major-tom-80": "#AA4646",
    "major-tom-90": "#BF4F4F",
    "major-tom-100": "#D45858",
    "major-tom-110": "#D86969",
    "major-tom-120": "#DD7979",
    "major-tom-130": "#E18A8A",
    "major-tom-140": "#E59B9B",
    "major-tom-150": "#E9ABAB",
    "major-tom-160": "#EEBCBC",
    "major-tom-170": "#F2CDCD",
    "major-tom-180": "#F6DEDE",
    "major-tom-190": "#FBEEEE",
    "sour-pink-10": "#15080D",
    "sour-pink-20": "#29101A",
    "sour-pink-30": "#3E1827",
    "sour-pink-40": "#522035",
    "sour-pink-50": "#672842",
    "sour-pink-60": "#7B304F",
    "sour-pink-70": "#90385C",
    "sour-pink-80": "#A44069",
    "sour-pink-90": "#B94876",
    "sour-pink-100": "#CD5084",
    "sour-pink-110": "#D26290",
    "sour-pink-120": "#D7739C",
    "sour-pink-130": "#DC85A9",
    "sour-pink-140": "#E196B5",
    "sour-pink-150": "#E6A8C1",
    "sour-pink-160": "#EBB9CE",
    "sour-pink-170": "#F0CBDA",
    "sour-pink-180": "#F5DCE6",
    "sour-pink-190": "#FAEEF3",
    "purp-10": "#131216",
    "purp-20": "#26232B",
    "purp-30": "#393541",
    "purp-40": "#4C4756",
    "purp-50": "#5E586C",
    "purp-60": "#716A81",
    "purp-70": "#847C97",
    "purp-80": "#978EAD",
    "purp-90": "#AA9FC2",
    "purp-100": "#BDB1D8",
    "purp-110": "#C4B9DC",
    "purp-120": "#CAC1E0",
    "purp-130": "#D1C8E4",
    "purp-140": "#D7D0E8",
    "purp-150": "#DED8EB",
    "purp-160": "#E5E0EF",
    "purp-170": "#EBE8F3",
    "purp-180": "#F2EFF7",
    "purp-190": "#F8F7FB",
    "uniq-1": "#383138",
    "uniq-2": "#BA94C1",
    "uniq-3": "#B18CB7",
    "uniq-4": "#2A2D22",
    "uniq-5": "#7DA889",
    "uniq-6": "#89B996",
    "uniq-7": "#A5B5FF",
    "maternitycare-1": "#B992BF",
    "maternitycare-2": "#A885AD",
    "maternitycare-3": "#BB94C1",
    "maternitycare-4": "#C9A5CC",
    "skincare-1": "#DC8CA1",
    "skincare-2": "#D7748E",
    "skincare-3": "#DB7B94",
    "skincare-4": "#DD879E",
    "vitamins-1": "#89B996",
    "vitamins-2": "#7DA889",
    "vitamins-3": "#5DC780",
    "vitamins-4": "#7DD299",
    "peronalcare-1": "#DBCB7D",
    "peronalcare-2": "#BEC081",
    "peronalcare-3": "#675541",
    "peronalcare-4": "#766858",
    "sexualhealth-1": "#E59B9B",
    "sexualhealth-2": "#BD9494",
    "sexualhealth-3": "#DA6464",
    "dentalcare-1": "#BECCC0",
    "dentalcare-2": "#A3B7A6",
    "dentalcare-3": "#6E9074",
    "haircare-1": "#666666",
    "haircare-2": "#545454",
    "haircare-3": "#333333",
    "eyecare-1": "#DBA47D",
    "eyecare-2": "#C99773",
    "eyecare-3": "#EEAB5E",
    "eyecare-4": "#DBCB7D",
    "nonotc-1": "#919FDC",
    "nonotc-2": "#9FAFF3",
  },
  borderRadius: {
    "r-nil": "0rem",
    "r-2": "0.125rem",
    "r-4": "0.25rem",
    "r-6": "0.375rem",
    "r-8": "0.5rem",
    "r-10": "0.625rem",
    "r-12": "0.75rem",
    "r-14": "0.875rem",
    "r-16": "1rem",
    "r-22": "1.375rem",
    "r-28": "1.75rem",
    "r-1": "0.0625rem",
  },
  fontFamily: {
    circular: "Circular Std, sans-serif",
    "gilroy-medium": "Gilroy-Medium, sans-serif",
    "gilroy-heavy": "Gilroy-Heavy, sans-serif",
    gilroy: "Gilroy, sans-serif",
    "gilroy-bold": "Gilroy-Bold, sans-serif",
  },
  fontWeight: {
    light: 300,
    book: 400,
    medium: 500,
    bold: 700,
    black: 900,
    ExtraBold: "ExtraBold",
    "Book Italic": 400,
  },
  fontSize: {
    "f-8": "0.5rem",
    "f-10": "0.625rem",
    "f-11": "0.6875rem",
    "f-12": "0.75rem",
    "f-13": "0.8125rem",
    "f-14": "0.875rem",
    "f-16": "1rem",
    "f-18": "1.125rem",
    "f-32": "2rem",
    "f-20": "1.25rem",
    "f-24": "1.5rem",
    "f-48": "3rem",
    "f-40": "2.5rem",
    "f-64": "4rem",
  },
  spacing: {
    "x-18": "1.125rem",
    "dynamic-mobile-x-18-height": "2.5280898876404496vh",
    "dynamic-mobile-x-18-width": "5vw",
    "dynamic-desktop-x-18-height": "1.6666666666666667vh",
    "dynamic-desktop-x-18-width": "0.9375vw",
    "x-24": "1.5rem",
    "dynamic-mobile-x-24-height": "3.3707865168539324vh",
    "dynamic-mobile-x-24-width": "6.666666666666667vw",
    "dynamic-desktop-x-24-height": "2.2222222222222223vh",
    "dynamic-desktop-x-24-width": "1.25vw",
    "x-26": "1.625rem",
    "dynamic-mobile-x-26-height": "3.651685393258427vh",
    "dynamic-mobile-x-26-width": "7.222222222222222vw",
    "dynamic-desktop-x-26-height": "2.4074074074074074vh",
    "dynamic-desktop-x-26-width": "1.3541666666666667vw",
    "x-32": "2rem",
    "dynamic-mobile-x-32-height": "4.49438202247191vh",
    "dynamic-mobile-x-32-width": "8.88888888888889vw",
    "dynamic-desktop-x-32-height": "2.962962962962963vh",
    "dynamic-desktop-x-32-width": "1.6666666666666667vw",
    "x-36": "2.25rem",
    "dynamic-mobile-x-36-height": "5.056179775280899vh",
    "dynamic-mobile-x-36-width": "10vw",
    "dynamic-desktop-x-36-height": "3.3333333333333335vh",
    "dynamic-desktop-x-36-width": "1.875vw",
    "x-38": "2.375rem",
    "dynamic-mobile-x-38-height": "5.337078651685394vh",
    "dynamic-mobile-x-38-width": "10.555555555555555vw",
    "dynamic-desktop-x-38-height": "3.5185185185185186vh",
    "dynamic-desktop-x-38-width": "1.9791666666666667vw",
    "x-40": "2.5rem",
    "dynamic-mobile-x-40-height": "5.617977528089888vh",
    "dynamic-mobile-x-40-width": "11.11111111111111vw",
    "dynamic-desktop-x-40-height": "3.7037037037037037vh",
    "dynamic-desktop-x-40-width": "2.0833333333333335vw",
    "x-44": "2.75rem",
    "dynamic-mobile-x-44-height": "6.179775280898877vh",
    "dynamic-mobile-x-44-width": "12.222222222222221vw",
    "dynamic-desktop-x-44-height": "4.074074074074074vh",
    "dynamic-desktop-x-44-width": "2.2916666666666665vw",
    "x-48": "3rem",
    "dynamic-mobile-x-48-height": "6.741573033707865vh",
    "dynamic-mobile-x-48-width": "13.333333333333334vw",
    "dynamic-desktop-x-48-height": "4.444444444444445vh",
    "dynamic-desktop-x-48-width": "2.5vw",
    "x-50": "3.125rem",
    "dynamic-mobile-x-50-height": "7.022471910112359vh",
    "dynamic-mobile-x-50-width": "13.88888888888889vw",
    "dynamic-desktop-x-50-height": "4.62962962962963vh",
    "dynamic-desktop-x-50-width": "2.6041666666666665vw",
    "x-52": "3.25rem",
    "dynamic-mobile-x-52-height": "7.303370786516854vh",
    "dynamic-mobile-x-52-width": "14.444444444444445vw",
    "dynamic-desktop-x-52-height": "4.814814814814815vh",
    "dynamic-desktop-x-52-width": "2.7083333333333335vw",
    "x-56": "3.5rem",
    "dynamic-mobile-x-56-height": "7.865168539325842vh",
    "dynamic-mobile-x-56-width": "15.555555555555555vw",
    "dynamic-desktop-x-56-height": "5.185185185185185vh",
    "dynamic-desktop-x-56-width": "2.9166666666666665vw",
    "x-60": "3.75rem",
    "dynamic-mobile-x-60-height": "8.426966292134832vh",
    "dynamic-mobile-x-60-width": "16.666666666666668vw",
    "dynamic-desktop-x-60-height": "5.555555555555555vh",
    "dynamic-desktop-x-60-width": "3.125vw",
    "x-62": "3.875rem",
    "dynamic-mobile-x-62-height": "8.707865168539326vh",
    "dynamic-mobile-x-62-width": "17.22222222222222vw",
    "dynamic-desktop-x-62-height": "5.7407407407407405vh",
    "dynamic-desktop-x-62-width": "3.2291666666666665vw",
    "x-64": "4rem",
    "dynamic-mobile-x-64-height": "8.98876404494382vh",
    "dynamic-mobile-x-64-width": "17.77777777777778vw",
    "dynamic-desktop-x-64-height": "5.925925925925926vh",
    "dynamic-desktop-x-64-width": "3.3333333333333335vw",
    "x-68": "4.25rem",
    "dynamic-mobile-x-68-height": "9.55056179775281vh",
    "dynamic-mobile-x-68-width": "18.88888888888889vw",
    "dynamic-desktop-x-68-height": "6.296296296296297vh",
    "dynamic-desktop-x-68-width": "3.5416666666666665vw",
    "x-70": "4.375rem",
    "dynamic-mobile-x-70-height": "9.831460674157304vh",
    "dynamic-mobile-x-70-width": "19.444444444444443vw",
    "dynamic-desktop-x-70-height": "6.481481481481482vh",
    "dynamic-desktop-x-70-width": "3.6458333333333335vw",
    "x-72": "4.5rem",
    "dynamic-mobile-x-72-height": "10.112359550561798vh",
    "dynamic-mobile-x-72-width": "20vw",
    "dynamic-desktop-x-72-height": "6.666666666666667vh",
    "dynamic-desktop-x-72-width": "3.75vw",
    "x-74": "4.625rem",
    "dynamic-mobile-x-74-height": "10.393258426966293vh",
    "dynamic-mobile-x-74-width": "20.555555555555557vw",
    "dynamic-desktop-x-74-height": "6.851851851851852vh",
    "dynamic-desktop-x-74-width": "3.8541666666666665vw",
    "x-76": "4.75rem",
    "dynamic-mobile-x-76-height": "10.674157303370787vh",
    "dynamic-mobile-x-76-width": "21.11111111111111vw",
    "dynamic-desktop-x-76-height": "7.037037037037037vh",
    "dynamic-desktop-x-76-width": "3.9583333333333335vw",
    "x-78": "4.875rem",
    "dynamic-mobile-x-78-height": "10.955056179775282vh",
    "dynamic-mobile-x-78-width": "21.666666666666668vw",
    "dynamic-desktop-x-78-height": "7.222222222222222vh",
    "dynamic-desktop-x-78-width": "4.0625vw",
    "x-80": "5rem",
    "dynamic-mobile-x-80-height": "11.235955056179776vh",
    "dynamic-mobile-x-80-width": "22.22222222222222vw",
    "dynamic-desktop-x-80-height": "7.407407407407407vh",
    "dynamic-desktop-x-80-width": "4.166666666666667vw",
    "x-82": "5.125rem",
    "dynamic-mobile-x-82-height": "11.51685393258427vh",
    "dynamic-mobile-x-82-width": "22.77777777777778vw",
    "dynamic-desktop-x-82-height": "7.592592592592593vh",
    "dynamic-desktop-x-82-width": "4.270833333333333vw",
    "x-84": "5.25rem",
    "dynamic-mobile-x-84-height": "11.797752808988765vh",
    "dynamic-mobile-x-84-width": "23.333333333333332vw",
    "dynamic-desktop-x-84-height": "7.777777777777778vh",
    "dynamic-desktop-x-84-width": "4.375vw",
    "x-88": "5.5rem",
    "dynamic-mobile-x-88-height": "12.359550561797754vh",
    "dynamic-mobile-x-88-width": "24.444444444444443vw",
    "dynamic-desktop-x-88-height": "8.148148148148149vh",
    "dynamic-desktop-x-88-width": "4.583333333333333vw",
    "x-90": "5.625rem",
    "dynamic-mobile-x-90-height": "12.640449438202246vh",
    "dynamic-mobile-x-90-width": "25vw",
    "dynamic-desktop-x-90-height": "8.333333333333334vh",
    "dynamic-desktop-x-90-width": "4.6875vw",
    "x-94": "5.875rem",
    "dynamic-mobile-x-94-height": "13.202247191011235vh",
    "dynamic-mobile-x-94-width": "26.11111111111111vw",
    "dynamic-desktop-x-94-height": "8.703703703703704vh",
    "dynamic-desktop-x-94-width": "4.895833333333333vw",
    "x-96": "6rem",
    "dynamic-mobile-x-96-height": "13.48314606741573vh",
    "dynamic-mobile-x-96-width": "26.666666666666668vw",
    "dynamic-desktop-x-96-height": "8.88888888888889vh",
    "dynamic-desktop-x-96-width": "5vw",
    "x-98": "6.125rem",
    "dynamic-mobile-x-98-height": "13.764044943820224vh",
    "dynamic-mobile-x-98-width": "27.22222222222222vw",
    "dynamic-desktop-x-98-height": "9.074074074074074vh",
    "dynamic-desktop-x-98-width": "5.104166666666667vw",
    "x-100": "6.25rem",
    "dynamic-mobile-x-100-height": "14.044943820224718vh",
    "dynamic-mobile-x-100-width": "27.77777777777778vw",
    "dynamic-desktop-x-100-height": "9.25925925925926vh",
    "dynamic-desktop-x-100-width": "5.208333333333333vw",
    "x-102": "6.375rem",
    "dynamic-mobile-x-102-height": "14.325842696629213vh",
    "dynamic-mobile-x-102-width": "28.333333333333332vw",
    "dynamic-desktop-x-102-height": "9.444444444444445vh",
    "dynamic-desktop-x-102-width": "5.3125vw",
    "x-104": "6.5rem",
    "dynamic-mobile-x-104-height": "14.606741573033707vh",
    "dynamic-mobile-x-104-width": "28.88888888888889vw",
    "dynamic-desktop-x-104-height": "9.62962962962963vh",
    "dynamic-desktop-x-104-width": "5.416666666666667vw",
    "x-108": "6.75rem",
    "dynamic-mobile-x-108-height": "15.168539325842696vh",
    "dynamic-mobile-x-108-width": "30vw",
    "dynamic-desktop-x-108-height": "10vh",
    "dynamic-desktop-x-108-width": "5.625vw",
    "x-112": "7rem",
    "dynamic-mobile-x-112-height": "15.730337078651685vh",
    "dynamic-mobile-x-112-width": "31.11111111111111vw",
    "dynamic-desktop-x-112-height": "10.37037037037037vh",
    "dynamic-desktop-x-112-width": "5.833333333333333vw",
    "x-114": "7.125rem",
    "dynamic-mobile-x-114-height": "16.01123595505618vh",
    "dynamic-mobile-x-114-width": "31.666666666666668vw",
    "dynamic-desktop-x-114-height": "10.555555555555555vh",
    "dynamic-desktop-x-114-width": "5.9375vw",
    "x-116": "7.25rem",
    "dynamic-mobile-x-116-height": "16.292134831460675vh",
    "dynamic-mobile-x-116-width": "32.22222222222222vw",
    "dynamic-desktop-x-116-height": "10.74074074074074vh",
    "dynamic-desktop-x-116-width": "6.041666666666667vw",
    "x-124": "7.75rem",
    "dynamic-mobile-x-124-height": "17.415730337078653vh",
    "dynamic-mobile-x-124-width": "34.44444444444444vw",
    "dynamic-desktop-x-124-height": "11.481481481481481vh",
    "dynamic-desktop-x-124-width": "6.458333333333333vw",
    "x-126": "7.875rem",
    "dynamic-mobile-x-126-height": "17.696629213483146vh",
    "dynamic-mobile-x-126-width": "35vw",
    "dynamic-desktop-x-126-height": "11.666666666666666vh",
    "dynamic-desktop-x-126-width": "6.5625vw",
    "x-132": "8.25rem",
    "dynamic-mobile-x-132-height": "18.53932584269663vh",
    "dynamic-mobile-x-132-width": "36.666666666666664vw",
    "dynamic-desktop-x-132-height": "12.222222222222221vh",
    "dynamic-desktop-x-132-width": "6.875vw",
    "x-136": "8.5rem",
    "dynamic-mobile-x-136-height": "19.10112359550562vh",
    "dynamic-mobile-x-136-width": "37.77777777777778vw",
    "dynamic-desktop-x-136-height": "12.592592592592593vh",
    "dynamic-desktop-x-136-width": "7.083333333333333vw",
    "x-140": "8.75rem",
    "dynamic-mobile-x-140-height": "19.662921348314608vh",
    "dynamic-mobile-x-140-width": "38.888888888888886vw",
    "dynamic-desktop-x-140-height": "12.962962962962964vh",
    "dynamic-desktop-x-140-width": "7.291666666666667vw",
    "x-144": "9rem",
    "dynamic-mobile-x-144-height": "20.224719101123597vh",
    "dynamic-mobile-x-144-width": "40vw",
    "dynamic-desktop-x-144-height": "13.333333333333334vh",
    "dynamic-desktop-x-144-width": "7.5vw",
    "x-146": "9.125rem",
    "dynamic-mobile-x-146-height": "20.50561797752809vh",
    "dynamic-mobile-x-146-width": "40.55555555555556vw",
    "dynamic-desktop-x-146-height": "13.518518518518519vh",
    "dynamic-desktop-x-146-width": "7.604166666666667vw",
    "x-150": "9.375rem",
    "dynamic-mobile-x-150-height": "21.06741573033708vh",
    "dynamic-mobile-x-150-width": "41.666666666666664vw",
    "dynamic-desktop-x-150-height": "13.88888888888889vh",
    "dynamic-desktop-x-150-width": "7.8125vw",
    "x-152": "9.5rem",
    "dynamic-mobile-x-152-height": "21.348314606741575vh",
    "dynamic-mobile-x-152-width": "42.22222222222222vw",
    "dynamic-desktop-x-152-height": "14.074074074074074vh",
    "dynamic-desktop-x-152-width": "7.916666666666667vw",
    "x-154": "9.625rem",
    "dynamic-mobile-x-154-height": "21.629213483146067vh",
    "dynamic-mobile-x-154-width": "42.77777777777778vw",
    "dynamic-desktop-x-154-height": "14.25925925925926vh",
    "dynamic-desktop-x-154-width": "8.020833333333334vw",
    "x-158": "9.875rem",
    "dynamic-mobile-x-158-height": "22.191011235955056vh",
    "dynamic-mobile-x-158-width": "43.888888888888886vw",
    "dynamic-desktop-x-158-height": "14.62962962962963vh",
    "dynamic-desktop-x-158-width": "8.229166666666666vw",
    "x-160": "10rem",
    "dynamic-mobile-x-160-height": "22.471910112359552vh",
    "dynamic-mobile-x-160-width": "44.44444444444444vw",
    "dynamic-desktop-x-160-height": "14.814814814814815vh",
    "dynamic-desktop-x-160-width": "8.333333333333334vw",
    "x-162": "10.125rem",
    "dynamic-mobile-x-162-height": "22.752808988764045vh",
    "dynamic-mobile-x-162-width": "45vw",
    "dynamic-desktop-x-162-height": "15vh",
    "dynamic-desktop-x-162-width": "8.4375vw",
    "x-168": "10.5rem",
    "dynamic-mobile-x-168-height": "23.59550561797753vh",
    "dynamic-mobile-x-168-width": "46.666666666666664vw",
    "dynamic-desktop-x-168-height": "15.555555555555555vh",
    "dynamic-desktop-x-168-width": "8.75vw",
    "x-182": "11.375rem",
    "dynamic-mobile-x-182-height": "25.56179775280899vh",
    "dynamic-mobile-x-182-width": "50.55555555555556vw",
    "dynamic-desktop-x-182-height": "16.85185185185185vh",
    "dynamic-desktop-x-182-width": "9.479166666666666vw",
    "x-188": "11.75rem",
    "dynamic-mobile-x-188-height": "26.40449438202247vh",
    "dynamic-mobile-x-188-width": "52.22222222222222vw",
    "dynamic-desktop-x-188-height": "17.40740740740741vh",
    "dynamic-desktop-x-188-width": "9.791666666666666vw",
    "x-192": "12rem",
    "dynamic-mobile-x-192-height": "26.96629213483146vh",
    "dynamic-mobile-x-192-width": "53.333333333333336vw",
    "dynamic-desktop-x-192-height": "17.77777777777778vh",
    "dynamic-desktop-x-192-width": "10vw",
    "x-194": "12.125rem",
    "dynamic-mobile-x-194-height": "27.247191011235955vh",
    "dynamic-mobile-x-194-width": "53.888888888888886vw",
    "dynamic-desktop-x-194-height": "17.962962962962962vh",
    "dynamic-desktop-x-194-width": "10.104166666666666vw",
    "x-196": "12.25rem",
    "dynamic-mobile-x-196-height": "27.528089887640448vh",
    "dynamic-mobile-x-196-width": "54.44444444444444vw",
    "dynamic-desktop-x-196-height": "18.14814814814815vh",
    "dynamic-desktop-x-196-width": "10.208333333333334vw",
    "x-208": "13rem",
    "dynamic-mobile-x-208-height": "29.213483146067414vh",
    "dynamic-mobile-x-208-width": "57.77777777777778vw",
    "dynamic-desktop-x-208-height": "19.25925925925926vh",
    "dynamic-desktop-x-208-width": "10.833333333333334vw",
    "x-212": "13.25rem",
    "dynamic-mobile-x-212-height": "29.775280898876403vh",
    "dynamic-mobile-x-212-width": "58.888888888888886vw",
    "dynamic-desktop-x-212-height": "19.62962962962963vh",
    "dynamic-desktop-x-212-width": "11.041666666666666vw",
    "x-216": "13.5rem",
    "dynamic-mobile-x-216-height": "30.337078651685392vh",
    "dynamic-mobile-x-216-width": "60vw",
    "dynamic-desktop-x-216-height": "20vh",
    "dynamic-desktop-x-216-width": "11.25vw",
    "x-220": "13.75rem",
    "dynamic-mobile-x-220-height": "30.89887640449438vh",
    "dynamic-mobile-x-220-width": "61.111111111111114vw",
    "dynamic-desktop-x-220-height": "20.37037037037037vh",
    "dynamic-desktop-x-220-width": "11.458333333333334vw",
    "x-226": "14.125rem",
    "dynamic-mobile-x-226-height": "31.741573033707866vh",
    "dynamic-mobile-x-226-width": "62.77777777777778vw",
    "dynamic-desktop-x-226-height": "20.925925925925927vh",
    "dynamic-desktop-x-226-width": "11.770833333333334vw",
    "x-240": "15rem",
    "dynamic-mobile-x-240-height": "33.70786516853933vh",
    "dynamic-mobile-x-240-width": "66.66666666666667vw",
    "dynamic-desktop-x-240-height": "22.22222222222222vh",
    "dynamic-desktop-x-240-width": "12.5vw",
    "x-248": "15.5rem",
    "dynamic-mobile-x-248-height": "34.831460674157306vh",
    "dynamic-mobile-x-248-width": "68.88888888888889vw",
    "dynamic-desktop-x-248-height": "22.962962962962962vh",
    "dynamic-desktop-x-248-width": "12.916666666666666vw",
    "x-250": "15.625rem",
    "dynamic-mobile-x-250-height": "35.1123595505618vh",
    "dynamic-mobile-x-250-width": "69.44444444444444vw",
    "dynamic-desktop-x-250-height": "23.14814814814815vh",
    "dynamic-desktop-x-250-width": "13.020833333333334vw",
    "x-252": "15.75rem",
    "dynamic-mobile-x-252-height": "35.39325842696629vh",
    "dynamic-mobile-x-252-width": "70vw",
    "dynamic-desktop-x-252-height": "23.333333333333332vh",
    "dynamic-desktop-x-252-width": "13.125vw",
    "x-256": "16rem",
    "dynamic-mobile-x-256-height": "35.95505617977528vh",
    "dynamic-mobile-x-256-width": "71.11111111111111vw",
    "dynamic-desktop-x-256-height": "23.703703703703702vh",
    "dynamic-desktop-x-256-width": "13.333333333333334vw",
    "x-262": "16.375rem",
    "dynamic-mobile-x-262-height": "36.79775280898876vh",
    "dynamic-mobile-x-262-width": "72.77777777777777vw",
    "dynamic-desktop-x-262-height": "24.25925925925926vh",
    "dynamic-desktop-x-262-width": "13.645833333333334vw",
    "x-264": "16.5rem",
    "dynamic-mobile-x-264-height": "37.07865168539326vh",
    "dynamic-mobile-x-264-width": "73.33333333333333vw",
    "dynamic-desktop-x-264-height": "24.444444444444443vh",
    "dynamic-desktop-x-264-width": "13.75vw",
    "x-274": "17.125rem",
    "dynamic-mobile-x-274-height": "38.48314606741573vh",
    "dynamic-mobile-x-274-width": "76.11111111111111vw",
    "dynamic-desktop-x-274-height": "25.37037037037037vh",
    "dynamic-desktop-x-274-width": "14.270833333333334vw",
    "x-280": "17.5rem",
    "dynamic-mobile-x-280-height": "39.325842696629216vh",
    "dynamic-mobile-x-280-width": "77.77777777777777vw",
    "dynamic-desktop-x-280-height": "25.925925925925927vh",
    "dynamic-desktop-x-280-width": "14.583333333333334vw",
    "x-282": "17.625rem",
    "dynamic-mobile-x-282-height": "39.60674157303371vh",
    "dynamic-mobile-x-282-width": "78.33333333333333vw",
    "dynamic-desktop-x-282-height": "26.11111111111111vh",
    "dynamic-desktop-x-282-width": "14.6875vw",
    "x-284": "17.75rem",
    "dynamic-mobile-x-284-height": "39.8876404494382vh",
    "dynamic-mobile-x-284-width": "78.88888888888889vw",
    "dynamic-desktop-x-284-height": "26.296296296296298vh",
    "dynamic-desktop-x-284-width": "14.791666666666666vw",
    "x-286": "17.875rem",
    "dynamic-mobile-x-286-height": "40.168539325842694vh",
    "dynamic-mobile-x-286-width": "79.44444444444444vw",
    "dynamic-desktop-x-286-height": "26.48148148148148vh",
    "dynamic-desktop-x-286-width": "14.895833333333334vw",
    "x-296": "18.5rem",
    "dynamic-mobile-x-296-height": "41.57303370786517vh",
    "dynamic-mobile-x-296-width": "82.22222222222223vw",
    "dynamic-desktop-x-296-height": "27.40740740740741vh",
    "dynamic-desktop-x-296-width": "15.416666666666666vw",
    "x-300": "18.75rem",
    "dynamic-mobile-x-300-height": "42.13483146067416vh",
    "dynamic-mobile-x-300-width": "83.33333333333333vw",
    "dynamic-desktop-x-300-height": "27.77777777777778vh",
    "dynamic-desktop-x-300-width": "15.625vw",
    "x-304": "19rem",
    "dynamic-mobile-x-304-height": "42.69662921348315vh",
    "dynamic-mobile-x-304-width": "84.44444444444444vw",
    "dynamic-desktop-x-304-height": "28.14814814814815vh",
    "dynamic-desktop-x-304-width": "15.833333333333334vw",
    "x-312": "19.5rem",
    "dynamic-mobile-x-312-height": "43.82022471910113vh",
    "dynamic-mobile-x-312-width": "86.66666666666667vw",
    "dynamic-desktop-x-312-height": "28.88888888888889vh",
    "dynamic-desktop-x-312-width": "16.25vw",
    "x-313": "19.5625rem",
    "dynamic-mobile-x-313-height": "43.96067415730337vh",
    "dynamic-mobile-x-313-width": "86.94444444444444vw",
    "dynamic-desktop-x-313-height": "28.98148148148148vh",
    "dynamic-desktop-x-313-width": "16.302083333333332vw",
    "x-316": "19.75rem",
    "dynamic-mobile-x-316-height": "44.38202247191011vh",
    "dynamic-mobile-x-316-width": "87.77777777777777vw",
    "dynamic-desktop-x-316-height": "29.25925925925926vh",
    "dynamic-desktop-x-316-width": "16.458333333333332vw",
    "x-320": "20rem",
    "dynamic-mobile-x-320-height": "44.943820224719104vh",
    "dynamic-mobile-x-320-width": "88.88888888888889vw",
    "dynamic-desktop-x-320-height": "29.62962962962963vh",
    "dynamic-desktop-x-320-width": "16.666666666666668vw",
    "x-328": "20.5rem",
    "dynamic-mobile-x-328-height": "46.06741573033708vh",
    "dynamic-mobile-x-328-width": "91.11111111111111vw",
    "dynamic-desktop-x-328-height": "30.37037037037037vh",
    "dynamic-desktop-x-328-width": "17.083333333333332vw",
    "x-336": "21rem",
    "dynamic-mobile-x-336-height": "47.19101123595506vh",
    "dynamic-mobile-x-336-width": "93.33333333333333vw",
    "dynamic-desktop-x-336-height": "31.11111111111111vh",
    "dynamic-desktop-x-336-width": "17.5vw",
    "x-340": "21.25rem",
    "dynamic-mobile-x-340-height": "47.752808988764045vh",
    "dynamic-mobile-x-340-width": "94.44444444444444vw",
    "dynamic-desktop-x-340-height": "31.48148148148148vh",
    "dynamic-desktop-x-340-width": "17.708333333333332vw",
    "x-344": "21.5rem",
    "dynamic-mobile-x-344-height": "48.31460674157304vh",
    "dynamic-mobile-x-344-width": "95.55555555555556vw",
    "dynamic-desktop-x-344-height": "31.85185185185185vh",
    "dynamic-desktop-x-344-width": "17.916666666666668vw",
    "x-352": "22rem",
    "dynamic-mobile-x-352-height": "49.438202247191015vh",
    "dynamic-mobile-x-352-width": "97.77777777777777vw",
    "dynamic-desktop-x-352-height": "32.592592592592595vh",
    "dynamic-desktop-x-352-width": "18.333333333333332vw",
    "x-360": "22.5rem",
    "dynamic-mobile-x-360-height": "50.561797752808985vh",
    "dynamic-mobile-x-360-width": "100vw",
    "dynamic-desktop-x-360-height": "33.333333333333336vh",
    "dynamic-desktop-x-360-width": "18.75vw",
    "x-366": "22.875rem",
    "dynamic-mobile-x-366-height": "51.40449438202247vh",
    "dynamic-mobile-x-366-width": "101.66666666666667vw",
    "dynamic-desktop-x-366-height": "33.888888888888886vh",
    "dynamic-desktop-x-366-width": "19.0625vw",
    "x-368": "23rem",
    "dynamic-mobile-x-368-height": "51.68539325842696vh",
    "dynamic-mobile-x-368-width": "102.22222222222223vw",
    "dynamic-desktop-x-368-height": "34.074074074074076vh",
    "dynamic-desktop-x-368-width": "19.166666666666668vw",
    "x-392": "24.5rem",
    "dynamic-mobile-x-392-height": "55.056179775280896vh",
    "dynamic-mobile-x-392-width": "108.88888888888889vw",
    "dynamic-desktop-x-392-height": "36.2962962962963vh",
    "dynamic-desktop-x-392-width": "20.416666666666668vw",
    "x-400": "25rem",
    "dynamic-mobile-x-400-height": "56.17977528089887vh",
    "dynamic-mobile-x-400-width": "111.11111111111111vw",
    "dynamic-desktop-x-400-height": "37.03703703703704vh",
    "dynamic-desktop-x-400-width": "20.833333333333332vw",
    "x-414": "25.875rem",
    "dynamic-mobile-x-414-height": "58.146067415730336vh",
    "dynamic-mobile-x-414-width": "115vw",
    "dynamic-desktop-x-414-height": "38.333333333333336vh",
    "dynamic-desktop-x-414-width": "21.5625vw",
    "x-422": "26.375rem",
    "dynamic-mobile-x-422-height": "59.26966292134831vh",
    "dynamic-mobile-x-422-width": "117.22222222222223vw",
    "dynamic-desktop-x-422-height": "39.074074074074076vh",
    "dynamic-desktop-x-422-width": "21.979166666666668vw",
    "x-514": "32.125rem",
    "dynamic-mobile-x-514-height": "72.19101123595506vh",
    "dynamic-mobile-x-514-width": "142.77777777777777vw",
    "dynamic-desktop-x-514-height": "47.592592592592595vh",
    "dynamic-desktop-x-514-width": "26.770833333333332vw",
    "x-590": "36.875rem",
    "dynamic-mobile-x-590-height": "82.86516853932584vh",
    "dynamic-mobile-x-590-width": "163.88888888888889vw",
    "dynamic-desktop-x-590-height": "54.629629629629626vh",
    "dynamic-desktop-x-590-width": "30.729166666666668vw",
    "x-622": "38.875rem",
    "dynamic-mobile-x-622-height": "87.35955056179775vh",
    "dynamic-mobile-x-622-width": "172.77777777777777vw",
    "dynamic-desktop-x-622-height": "57.592592592592595vh",
    "dynamic-desktop-x-622-width": "32.395833333333336vw",
    "x-878": "54.875rem",
    "dynamic-mobile-x-878-height": "123.31460674157303vh",
    "dynamic-mobile-x-878-width": "243.88888888888889vw",
    "dynamic-desktop-x-878-height": "81.29629629629629vh",
    "dynamic-desktop-x-878-width": "45.729166666666664vw",
    "x-978": "61.125rem",
    "dynamic-mobile-x-978-height": "137.35955056179776vh",
    "dynamic-mobile-x-978-width": "271.6666666666667vw",
    "dynamic-desktop-x-978-height": "90.55555555555556vh",
    "dynamic-desktop-x-978-width": "50.9375vw",
    "x-1192": "74.5rem",
    "dynamic-mobile-x-1192-height": "167.41573033707866vh",
    "dynamic-mobile-x-1192-width": "331.1111111111111vw",
    "dynamic-desktop-x-1192-height": "110.37037037037037vh",
    "dynamic-desktop-x-1192-width": "62.083333333333336vw",
    "x-1264": "79rem",
    "dynamic-mobile-x-1264-height": "177.52808988764045vh",
    "dynamic-mobile-x-1264-width": "351.1111111111111vw",
    "dynamic-desktop-x-1264-height": "117.03703703703704vh",
    "dynamic-desktop-x-1264-width": "65.83333333333333vw",
    "x-1920": "120rem",
    "dynamic-mobile-x-1920-height": "269.6629213483146vh",
    "dynamic-mobile-x-1920-width": "533.3333333333334vw",
    "dynamic-desktop-x-1920-height": "177.77777777777777vh",
    "dynamic-desktop-x-1920-width": "100vw",
    "x-1636": "102.25rem",
    "dynamic-mobile-x-1636-height": "229.77528089887642vh",
    "dynamic-mobile-x-1636-width": "454.44444444444446vw",
    "dynamic-desktop-x-1636-height": "151.4814814814815vh",
    "dynamic-desktop-x-1636-width": "85.20833333333333vw",
    "x-836": "52.25rem",
    "dynamic-mobile-x-836-height": "117.41573033707866vh",
    "dynamic-mobile-x-836-width": "232.22222222222223vw",
    "dynamic-desktop-x-836-height": "77.4074074074074vh",
    "dynamic-desktop-x-836-width": "43.541666666666664vw",
  },
  lineHeight: {
    auto: "inherit",
  },
  letterSpacing: {
    "l-0": "0rem",
    "l-1": "0.01rem",
    "l-2": "0.02rem",
    "l-3": "0.03rem",
  },
  borderWidth: {
    "b-0 3": "0.01875rem",
    "b-0 5": "0.03125rem",
    "b-1": "0.0625rem",
    "b-nil": "0rem",
  },
  opacity: {
    "o-30": "30%",
    "o-96": "6rem",
  },
};

export const miles_plugin_components = {};
